/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Nebula Edits: product pair option */
  const moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    
  document.addEventListener('change', function(e) {
    if (e.target.matches('.radio__buttons input[type="radio"]')) {
        e.preventDefault();
        console.log("here to change");
        
        var pairOption = document.getElementById('pair-option');
        if (pairOption.checked) {
          const parentElement = e.target.closest(".radio__fieldset");
            document.querySelector('.product-form input[name="quantity"]').value = 2;
            document.querySelector('div[data-option-position="1"] .radio__legend__value').textContent = "Pair";
            var doublePrice = pairOption.getAttribute('data-price');
            var comDoublePrice = pairOption.getAttribute('data-compare-price');
            
            if (doublePrice) {
                var pairPrice = formatMoney(doublePrice * 2, theme.moneyFormat);
                var pairComPrice = formatMoney(comDoublePrice * 2, theme.moneyFormat);
                
                var productPriceSpan = document.querySelector('.product__price__wrap .product__price span');
                var productPriceOffSpan = document.querySelector('.product__price__wrap .product__price--off span');
                
                if (productPriceSpan) {
                    productPriceSpan.textContent = pairPrice;
                }
                if (productPriceOffSpan && pairComPrice) {
                    productPriceOffSpan.textContent = pairComPrice;
                }
            }
            if(document.querySelectorAll(".product__thumbs").length > 0 && document.querySelector(`div[data-option-position="2"]`)){
               const selectedSecondvalue = document.querySelector(`div[data-option-position="2"] .radio__buttons input[type="radio"]:checked`).value;
           
              const pairSelection =  `@Pair||${selectedSecondvalue}`;
              document.querySelectorAll(".product__thumbs .product__thumb a").forEach((el) => {
                const imagetag = el.querySelector("img");
                console.log(imagetag.getAttribute("alt"), pairSelection,"pairSelection");
                if(imagetag.getAttribute("alt") == pairSelection){
                  el.click();
                  
                }
              })
            }
        }else{
           document.querySelector('.product-form input[name="quantity"]').value = 1;
        }
    }
});
 
  /* End Nebula Edits: Product pair option */


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener('theme:product:added',async(evt) => {
   const cartSection = await  fetch(theme.routes.root);
    const responseData = await cartSection.text();
        const element = document.createElement('div');
        element.innerHTML = responseData;

        const cleanResponse = element.querySelector('.custom-bar-div');
        document.querySelector(".custom-bar-div").innerHTML = cleanResponse.innerHTML;
        

  });
});
